import { getAuth, signOut } from "firebase/auth";
import { clear2FASession } from "../../services/twoFactorService";

/**
 * Logs out the user and clears 2FA session
 *
 * @param {function} navigate - Navigation function
 */
export async function logoutUser(navigate) {
  const auth = getAuth();
  const user = auth.currentUser;
  
  try {
    // Clear 2FA session if user exists
    if (user) {
      await clear2FASession(user.uid);
    }
    
    // Sign out from Firebase Auth
    await signOut(auth);
    navigate("/", { replace: true });
  } catch (error) {
    console.error("Error during logout:", error);
    // Still navigate even if 2FA session clearing fails
    navigate("/", { replace: true });
  }
}
